export class BrowserStore {
    constructor(prefix) {
        this.memory = new Map();
        this.prefix = prefix;
    }
    readString(key) {
        const namespaced = this.key(key);
        try {
            return window.localStorage.getItem(namespaced);
        }
        catch {
            return this.memory.get(namespaced) ?? null;
        }
    }
    writeString(key, value) {
        const namespaced = this.key(key);
        try {
            window.localStorage.setItem(namespaced, value);
            this.memory.delete(namespaced);
        }
        catch {
            this.memory.set(namespaced, value);
        }
    }
    clear(key) {
        const namespaced = this.key(key);
        try {
            window.localStorage.removeItem(namespaced);
        }
        catch {
            // noop
        }
        this.memory.delete(namespaced);
    }
    readJson(key) {
        const raw = this.readString(key);
        if (!raw) {
            return null;
        }
        try {
            return JSON.parse(raw);
        }
        catch {
            return null;
        }
    }
    writeJson(key, value) {
        this.writeString(key, JSON.stringify(value));
    }
    key(key) {
        return `${this.prefix}:${key}`;
    }
}
//# sourceMappingURL=browser-store.js.map